import { render, staticRenderFns } from "./cargaPorCaminhao.vue?vue&type=template&id=ec6d46a6&"
import script from "./cargaPorCaminhao.vue?vue&type=script&lang=js&"
export * from "./cargaPorCaminhao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports